import React, { useEffect, useRef, useState } from 'react';
import {
	ProductAlign,
	ProductRatings,
	ProductRatingText,
	ProductWrapper,
	ProductRatingsWrapper,
} from './ratingList.styled';
import { RepeaterItem, ProItem, ConItem } from 'types/globalTypes';
import { Paragraph } from '@components/core/paragraph/Paragraph';
import RatingBar from '../ratingBar/RatingBar';

export interface RatingListProps {
	productImage?: string;
	showRatings?: boolean;
	ratingRepeater?: RepeaterItem[];
	prosRepeater?: ProItem[];
	consRepeater?: ConItem[];
	reviewScoreLabel?: string;
	$barBackground?: string;
	$barColor?: string;
}

const RatingList: React.FC<RatingListProps> = ({
	ratingRepeater = [],
	$barBackground,
	$barColor,
	showRatings = true,
}) => {
	const labelRefs = useRef<(HTMLDivElement | null)[]>([]);
	const [labelWidth, setLabelWidth] = useState<number>(0);

	useEffect(() => {
		if (!ratingRepeater.length) return;

		const observers: ResizeObserver[] = [];

		const updateWidths = () => {
			const widths = labelRefs.current.map((ref) => ref?.offsetWidth || 0);
			const max = Math.max(...widths);
			setLabelWidth(max);
		};

		labelRefs.current.forEach((el) => {
			if (!el) return;
			const observer = new ResizeObserver(() => {
				updateWidths();
			});
			observer.observe(el);
			observers.push(observer);
		});

		// Initial call
		updateWidths();

		// Cleanup
		return () => {
			observers.forEach((observer) => observer.disconnect());
		};
	}, [ratingRepeater]);

	return (
		<ProductWrapper style={{ justifyContent: !showRatings ? 'space-around' : 'space-between' }}>
			{showRatings && (
				<ProductRatingsWrapper>
					{ratingRepeater.map(({ tr_text_label, rating_score }, i) => (
						<ProductRatings key={`${tr_text_label}-${i}`}>
							<ProductRatingText
								ref={(el: HTMLDivElement | null) => (labelRefs.current[i] = el)}
								$width={`auto`}
							>
								{tr_text_label}
							</ProductRatingText>
							{labelWidth !== 0 && (
								<ProductAlign $width={labelWidth}>
									<RatingBar
										rating={Number(rating_score)}
										$height="8px"
										$rounded
										$width={labelWidth}
										$barColor={$barColor}
										$barBackground={$barBackground}
									/>

									<Paragraph $color="#333" $variant="tiny">
										{rating_score}/10
									</Paragraph>
								</ProductAlign>
							)}
						</ProductRatings>
					))}
				</ProductRatingsWrapper>
			)}
		</ProductWrapper>
	);
};

export default RatingList;
